import { registerGloballyAvailableFunctions } from './globally-available-functions';

export function initializeLibrary() {
  return () => {
    registerGloballyAvailableFunctions();
  };
}
